import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ISystemMessagesApi } from "@/api/system-messages";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { SystemMessage } from "@/models/system-message";
import { useToast } from "@/hooks/use-toast";

export const useDeleteSystemMessage = () => {
  const systemMessagesApi = useInjection<ISystemMessagesApi>(SERVICES_TYPES.SYSTEM_MESSAGES);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) => systemMessagesApi.remove(id),
    onSuccess: (_data, id) => {
      queryClient.setQueryData<SystemMessage[]>(["system-messages"], (current) =>
        current?.filter((item) => item._id !== id)
      );
      toast({ title: "System message deleted" });
    },
    onError: (error) => {
      toast({
        title: "Failed to delete system message",
        description: error.message,
        variant: "destructive"
      });
    }
  });
};
